<!-- 客户过滤器组件 -->
<template>
    <el-dialog title="选择客户" :visible.sync="isShow" :before-close="handleClose" width="55%">
        <el-form :model="searchModel" ref="form" :rules="rules" :inline="true" label-width="80px">
            <el-form-item label="客户名称">
                <el-input v-model="searchModel.name" :clearable="true" placeholder="输入客户名称快速检索"></el-input>
            </el-form-item>
            <district-linkage
                    :province-id="parseInt(searchModel.province_id)"
                    :city-id="parseInt(searchModel.city_id)"
                    :district-id="parseInt(searchModel.district_id)"
                    @change="handleChange"
            ></district-linkage>
            <!--<el-form-item>-->
            <!--<el-button type="primary" icon="el-icon-search">搜 索</el-button>-->
            <!--</el-form-item>-->
        </el-form>

        <el-row style="margin-bottom:10px;">
            <el-tag v-if="currentRow"> 当前选择: {{currentRow.name}}</el-tag>
        </el-row>


        <el-table
                :data="customers"
                border style="width: 100%"
                height="400"
                v-loading="loading"
                highlight-current-row
                @current-change="handleCurrentChange"
        >
            <el-table-column prop="id" label="ID" width="100"></el-table-column>
            <el-table-column prop="name" label="客户名称">
                <template slot-scope="scope">
                    <span v-if="filterIsBind && scope.row.is_bind">
                        {{scope.row.name}} 
                        <span v-if="scope.row.child">
                            <CustomerChild  :customerId="scope.row.id" :masterName="scope.row.name" :routePath="$route.path" @cancelMerge="handleCancelMerge($event)"></CustomerChild>
                        </span>
                        <i style="color: #F56C6C;">[已绑定]</i>
                    </span>
                    <span v-else>
                        {{scope.row.name}}
                        <!-- <el-button v-if="Acs('/customers/bind')" @click="bindCustomer(scope.row)" type="text">绑定</el-button> -->
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="业务员">
                <template slot-scope="scope">
                    <span v-if="scope.row.user != null">{{scope.row.user.name}}</span>
                </template>
            </el-table-column>
            <el-table-column label="协作人">
                <template slot-scope="scope">
                    <div v-for="(cooperator, index) in scope.row.cooperator" :key="index">{{cooperator.user_name}}</div>
                </template>
            </el-table-column>
            <el-table-column label="所属部门">
                <template slot-scope="scope">
                    <span v-if="scope.row.user != null">{{scope.row.user.branch_name}}</span>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="username" label="业务员"></el-table-column> -->
            <el-table-column prop="district_names" label="所在地区"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-row style="margin-top:20px;" v-if="customerLinkPage">
            <pagination :linkPage="customerLinkPage" :enableEvent="true" @change="watchPageChange"></pagination>
        </el-row>

        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button :disabled="disableBtn" type="warning" @click="handleSelect(0)">仅关联客户</el-button>
            <el-button :disabled="disableBtn" type="primary" @click="handleSelect(1)">关联并绑定客户</el-button>
        </div>

    </el-dialog>
</template>

<script>
    import DistrictLinkage from "~/widgets/DistrictLinkage.vue";
    import Pagination from "~/widgets/Pagination.vue";
    import CommonService from "~/services/common";
    import CustomerService from "~/services/customer";
    import CustomerChild from "~/widgets/CustomerChild.vue";

    export default {
        name: "CustomerFilter",
        components: {
            DistrictLinkage,
            Pagination,
            CustomerChild
        },
        props: {
            showDialog: {
                type: Boolean,
                required: false
            },
            filterIsBind: {
                type: Boolean,
                required: false,
                //default: false
            },

            defaultProvince: {
                type: Number,
                default: 0,
                required: false,
            },

            defaultCity: {
                type: Number,
                default: 0,
                required: false
            },

            defaultDistrict: {
                type: Number,
                default: 0,
                required: false
            },

            // 线索记录模型
            clue: {
                type: Object,
                default: null,
                required: false,
            }
        },
        data() {
            return {
                searchModel: {
                    province_id: 0,
                    city_id: 0,
                    district_id: 0,
                    name: '',
                    enableAuthQuery: '', //不校验数据权限
                    enableParentQuery: '', //不查询主客户
                },
                disableBtn: true,
                customers: [],
                isShow: false,
                loading: false,
                rules: {},
                currentRow: null, // 当前选中行数据
                customerLinkPage: null,
                getting: false
            };
        },
        watch: {
            showDialog: function (value, original) {
                this.isShow = value;
            },

            'searchModel.name': function (value, original) {

                    let interval = setInterval(()=>{
                        if(!this.getting){
                            clearInterval(interval);
                            this.getCustomers(this.searchModel);
                        }
                    },200)


            },
        },

        created: function () {
            if (this.showDialog && !this.isShow) {
                this.isShow = this.showDialog;
            }
        },

        mounted: function _() {
            if (this.defaultProvince) {
                this.searchModel.province_id = parseInt(this.defaultProvince);
            }
            if (this.defaultCity) {
                this.searchModel.city_id = parseInt(this.defaultCity);
            }
            if (this.defaultDistrict) {
                this.searchModel.district_id = parseInt(this.defaultDistrict);
            }
            if (this.customers.length < 1) {
                this.getCustomers(this.searchModel);
            }
        },
        methods: {
            // 关闭窗口
            handleClose() {
                this.close();
            },

            // 关闭当前窗口
            close() {
                this.isShow = false;
                // 往上层组件传递更改后的状态
                this.$emit("watchModalClose", this.isShow);
            },

            // 监听地区筛选组件的 Change 事件
            handleChange(district) {

                let isChange = false;

                if (this.searchModel.province_id != district[0]) {
                    this.searchModel.province_id = district[0];
                    this.searchModel.city_id = 0;
                    this.searchModel.district_id = 0;
                    isChange = true;
                }

                if (this.searchModel.city_id != district[1]) {
                    this.searchModel.city_id = district[1];
                    this.searchModel.district_id = 0;
                    isChange = true;
                }

                if (this.searchModel.district_id != district[2]) {
                    this.searchModel.district_id = district[2];
                    isChange = true;
                }

                if (isChange) {
                    this.getCustomers(this.searchModel);
                }
            },

            getCustomers(params) {
                let reqParam = {};
                if (params) {
                    reqParam = JSON.parse(JSON.stringify(params));
                } else {
                    reqParam = {};
                }

                this.loading = true;
                this.getting = true;
                //params[fields] = 'id,name';
                setTimeout(() => {
                    CommonService.getCustomerList(reqParam).then(res => {
                        this.loading = false;
                        this.getting = false
                        if (res.data) {
                            this.customers = res.data;
                            if (res._meta) {
                                this.customerLinkPage = res._meta;
                            }
                        }
                    });
                }, 500);
            },

            handleCurrentChange(currentRow) {
                if (!currentRow) {
                    return;
                }
                if (this.filterIsBind && currentRow.is_bind && currentRow.user_id !== this.$store.getters.userId) {
                    this.$message({
                        type: "error",
                        message: "只可以选择自己绑定的客户"
                    });
                    return;
                }

                this.currentRow = currentRow;
                if (this.currentRow && this.currentRow.name) {
                    this.disableBtn = false;
                }
            },

            handleSelect(sub_type = 0) {
                if (!this.currentRow || !this.currentRow.name) {
                    this.$message({
                        type: "error",
                        message: "请选择一个有效的客户"
                    });
                    return;
                }
                if(this.clue && this.clue.status == 0){
                    this.$confirm('关联客户前，请先标记线索真实性', '提示', {
                        confirmButtonText: '去标记',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        if (this.$route.path != '/sales-leads/view'){
                            let routeData = this.$router.resolve({
                                path: "/sales-leads/view",
                                query: {id: this.clue.id, check_status: this.clue.id},
                            });
                            window.open(routeData.href, '_blank');
                        }
                    })
                    this.close();
                    return false;
                }
                this.$emit("filterCallback", this.currentRow, sub_type);
                this.close();
            },

            /**
             * 监听分页改变事件
             * @param params
             */
            watchPageChange(pageParams) {
                let params = this.searchModel;
                params['page'] = pageParams['page'];
                params['perPage'] = pageParams['perPage'];
                this.getCustomers(params);
            },

            bindCustomer(customer) {

                this.$confirm("确定要绑定该客户吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true
                }).then(() => {

                    let userId = this.$store.getters.userId;
                    let params = {
                        user_id: userId,
                        customer_ids: [customer.id]
                    };

                    CustomerService.bind(params).then(res => {
                        if (res.code == 0) {
                            this.$message.success('绑定成功');
                            this.getCustomers(this.searchModel);
                        }
                    });
                }).catch(() => {
                });

            },
            // 查看、编辑、删除、绑定、转交销售线索操作
            handleView(clue) {
                let routeData = this.$router.resolve({
                    path: "/customers/view",
                    query: { id: clue.id, referer: this.$route.path },
                });
                window.open(routeData.href, '_blank');
            },
            //取消合并
            handleCancelMerge(value) {
                this.getCustomers(params);
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/widgets/CustomerFilter.vue